
// Styles Entry Point
import './app.scss';

//jquery 
import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

//Bootstrap
import './bootstrap';

import './components';

//images
require.context('./', true, /\.(png|svg|jpe?g|gif)$/);
